/**
 * Converts kebab-case to PascalCase.
 *
 * @export
 * @param {string} snakeCase
 * @return {*} {string}
 */
export function kebabToPascalCase(snakeCase: string): string {
    return snakeCase.replace(/(\w)(\w*)(-?)/g, (_, firstChar, restOfWord) => firstChar.toUpperCase() + restOfWord.toLowerCase());
}
